<div (mouseleave)="close()" class="layout-column custom-panel full-width full-height">
  <div *ngFor="let item of data"
       (click)="onClick(item)"
       [class.disabled]="item.disabled"
       class="layout-row layout-align-start-center pointer padding-10 gap-5">
    <bringoz-icon iconName="{{ item.iconName }}" class="gray-102"></bringoz-icon>
    <span class="flex br-body-2 font-weight-400">{{ item.name | translate }}</span>
  </div>
</div>
